<h3>{{NameDescription}}
</h3>
<div class="row">
    <div class="col"> Open Bookings
    </div>
    <div class="col" align="right">Total: {{bookings?bookings.length:0}}
    </div>
</div>
<div align="center" *ngIf="Error">
    {{Error}}
</div>
<mat-dialog-content class="mat-typography" style="padding: 10px">
    <p *ngFor="let booking of bookings">
        <mat-card appearance="outlined">
            <div class="row">
                <div class="col">
                    <strong> {{booking.ItemNumberDV}}</strong>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    Booking#: {{booking.BookingNumber}}
                </div>
            </div>
            <div class="row">
                <div class="col">
                    {{booking.BookingDate | date:'MM/dd/yyyy'}}
                </div>
                <div class="col" align="right">
                    {{booking.BookingQuantity}} {{booking.QuantityUOM}}
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <span><i class="fa fa-map-marker color_green" aria-hidden="true"></i>
                        {{booking.BookingLocation}} </span>
                </div>
                <div class="col" align="right">
                    {{booking.TransactionAmount | currency}}
                </div>
            </div>
        </mat-card>
    </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button class="ta-openbooking-close text-white magin_5 btn btn-success"  [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>